// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2K3yI","validationTips":"StatementDescriptor_validationTips__2RANv"};